import React from 'react';
import PropTypes from 'prop-types';

const BannerCard = ({ name, appDetails, busImageUrl }) => {
  return (
    <div className="w-full max-w-full rounded-lg overflow-hidden shadow-md bg-[#BE1F18] px-2 sm:px-4 mx-auto flex items-center justify-between">

      <div className="flex-1">
      
      <h2 className="text-sm sm:text-lg text-white">Assalam o Alaikum!</h2>
        <h2 className="font-bold italic text-sm sm:text-lg mb-2 text-white">{name}</h2>
        <p className="text-white text-xs sm:text-sm">{appDetails}</p>
      </div>
      <div className="flex-shrink-0 w-24 sm:w-32 md:w-48">
        <img src={busImageUrl} alt="Bus" className="w-full h-auto object-cover" />
      </div>
    </div>
  );
};

BannerCard.propTypes = {
  name: PropTypes.string.isRequired,
  appDetails: PropTypes.string.isRequired,
  busImageUrl: PropTypes.string.isRequired,
};

export default BannerCard;
